import {styled} from '@mui/material/styles'

const PREFIX = 'SelectedPersona'

export const classesIP = {
  root: `${PREFIX}-root`,
  personaTitleColorhpBaseDark: `${PREFIX}-personaTitleColorhpBaseDark`,
  personaTitleColorTeal: `${PREFIX}-personaTitleColorTeal`,
  personaTitle: `${PREFIX}-personaTitle`,
  personaStackSubTitle2: `${PREFIX}-personaStackSubTitle2`,
  personaSelectCustom: `${PREFIX}-personaSelectCustom`,
  personaSubTitle: `${PREFIX}-personaSubTitle`,
  personaParagraph: `${PREFIX}-personaParagraph`,
  personaSubTitle2: `${PREFIX}-personaSubTitle2`,
  personaStackText: `${PREFIX}-personaStackText`,
  overviewIcons: `${PREFIX}-overviewIcons`,
  overviewStack: `${PREFIX}-overviewStack`,
  overviewBox: `${PREFIX}-overviewBox`,
  overviewKeyChar1Icon: `${PREFIX}-overviewKeyChar1Icon`,
  overviewKeyChar1Stack: `${PREFIX}-overviewKeyChar1Stack`,
  overviewKeyChar2Stack: `${PREFIX}-overviewKeyChar2Stack`,
  personaHCB: `${PREFIX}-personaHCB`,
  OverviewLinearProgressText: `${PREFIX}-OverviewLinearProgressText`,
  OverviewLinearProgressBox1: `${PREFIX}-OverviewLinearProgressBox1`,
  OverviewLinearProgressBox2: `${PREFIX}-OverviewLinearProgressBox2`,
  OverviewLinearProgressBox2Child: `${PREFIX}-OverviewLinearProgressBox2Child`,
  OverviewLinearProgressBox3: `${PREFIX}-OverviewLinearProgressBox3`,
  personaCustomBox: `${PREFIX}-personaCustomBox`,
  personaHeaderStack: `${PREFIX}-personaHeaderStack`,
  personaHeaderStackMargin: `${PREFIX}-personaHeaderStackMargin`,
  personaIcon: `${PREFIX}-personaIcon`,
  engagementPercent: `${PREFIX}-engagementPercent`,
  engagementDetail: `${PREFIX}-engagementDetail`,
  engagementText: `${PREFIX}-engagementText`,
  outreachLabel: `${PREFIX}-outreachLabel`,
  CircularProgress: `${PREFIX}-CircularProgress`,
  Box: `${PREFIX}-Box`,
  Paper: `${PREFIX}-Paper`,
  Stack: `${PREFIX}-Stack`,
  SubStack: `${PREFIX}-SubStack`,
  StackChildHalf: `${PREFIX}-StackChildHalf`,
  StackChildFull: `${PREFIX}-StackChildFull`,
  Title: `${PREFIX}-Title`,
  overviewKeyChar1StackChild: `${PREFIX}-overviewKeyChar1StackChild`,
  wide: `${PREFIX}-wide`,
  outreachWide: `${PREFIX}-outreachWide`
}

export const Root = styled('div')(({theme}) => ({
  [`& .${classesIP.root}`]: {
    display: 'flex'
  },

  [`& .${classesIP.personaTitle}`]: {
    color: theme.palette.hpBaseDarker,
    fontSize: theme.typography.h5.fontSize,
    fontWeight: theme.typography.fontWeightBold
  },
  [`& .${classesIP.personaSubTitle}`]: {
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: theme.typography.listItemMedium?.fontSize,
    color: theme.palette.hpBaseDark,
    lineHeight: theme.typography.overline?.lineHeight
  },
  [`& .${classesIP.personaSubTitle2}`]: {
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.bodyLarge?.fontSize,
    color: theme.palette.hpAccentTeal,
    lineHeight: 1.5
  },
  [`& .${classesIP.personaStackText}`]: {
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.body2.fontSize,
    color: theme.palette.hpBaseDark,
    marginTop: 5,
    marginBottom: 6,
    textAlign: 'center'
  },
  [`& .${classesIP.personaParagraph}`]: {
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.subtitle3?.fontSize,
    color: theme.palette.hpBlack
  },
  [`& .${classesIP.summaryTitleColorTeal}`]: {
    color: theme.palette.hpAccentTeal
  },

  [`& .${classesIP.personaTitleColorhpBaseDark}`]: {
    color: theme.palette.hpBaseDark
  },
  [`& .${classesIP.personaCustomBox}`]: {
    color: theme.palette.hpBaseDark,
    marginTop: 5,
    fontWeight: theme.typography.fontWeightMedium
  },
  [`& .${classesIP.personaStackSubTitle2}`]: {
    fontSize: theme.typography.body1.fontSize,
    color: theme.palette.hpAccentRed
  },
  [`& .${classesIP.personaSelectCustom}`]: {
    border: '1px solid theme.palette.hpBaseLight',
    height: 35,
    fontColor: theme.palette.hpBaseDarker,
    color: theme.palette.hpBaseDarker
  },
  [`& .${classesIP.overviewKeyChar1Stack}`]: {
    alignItems: 'center',
    flexWrap: 'wrap',
    cursor: 'default',
    justifyContent: 'center'
  },

  [`& .${classesIP.wide}`]: {
    width: '100%'
  },
  [`& .${classesIP.overviewIcons}`]: {
    fontSize: theme.typography.h5?.fontSize,
    strokeWidth: 1,
    marginTop: -0.6,
    marginLeft: -0.6
  },
  [`& .${classesIP.overviewKeyChar1Icon}`]: {
    fontSize: theme.typography.headingLarge?.fontSize,
    strokeWidth: 1
  },
  [`& .${classesIP.overviewKeyChar2Stack}`]: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: -2
  },
  [`& .${classesIP.overviewStack}`]: {
    alignItems: 'center',
    fontWeight: 500,
    marginTop: 6,
    marginLeft: -1,
    cursor: 'pointer'
  },
  [`& .${classesIP.overviewBox}`]: {
    marginTop: 10
  },
  [`& .${classesIP.personaHCB}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    marginTop: -15
  },
  [`& .${classesIP.personaHeaderStack}`]: {
    marginTop: 5,
    justifyContent: 'start',
    alignItems: 'center'
  },
  [`& .${classesIP.personaHeaderStackMargin}`]: {
    marginTop: -5,
    marginLeft: 8
  },
  [`& .${classesIP.personaIcon}`]: {
    fontSize: theme.typography.h5?.fontSize,
    strokeWidth: 1,
    marginTop: -0.5
  },
  [`& .${classesIP.OverviewLinearProgressBox1}`]: {
    display: 'flex',
    alignItems: 'start',
    flexDirection: 'column',
    marginTop: 2,
    marginBottom: 2
  },
  [`& .${classesIP.OverviewLinearProgressBox2}`]: {
    display: 'flex',
    alignItems: 'center'
  },
  [`& .${classesIP.OverviewLinearProgressBox2Child}`]: {
    minWidth: 180,
    marginRight: 1
  },
  [`& .${classesIP.OverviewLinearProgressBox3}`]: {
    color: theme.palette.hpBaseDark,
    minWidth: 35,
    marginLeft: 6
  },
  [`& .${classesIP.OverviewLinearProgressText}`]: {
    mt: 1,
    alignItems: 'start'
  },
  [`& .${classesIP.engagementPercent}`]: {
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.bodyMedium?.fontSize,
    color: theme.palette.hpAccentTeal
  },
  [`& .${classesIP.engagementDetail}`]: {
    fontSize: theme.typography.labelSmall?.fontSize,
    fontWeight: theme.typography.fontWeightRegular,
    color: theme.palette.hpBaseDark,
    textAlign: 'center'
  },
  [`& .${classesIP.engagementText}`]: {
    fontSize: theme.typography.labelMedium?.fontSize,
    fontWeight: theme.typography.fontWeightRegular,
    color: theme.palette.hpBaseDark,
    textAlign: 'center'
  },
  [`& .${classesIP.outreachLabel}`]: {
    fontSize: theme.typography.bodySmall?.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.hpAccentTeal
  },
  [`& .${classesIP.outreachWide}`]: {
    textAlign: 'center',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    alignItems: 'center',
    justifyContent: 'center',
    width: 150
  },

  [`& .${classesIP.CircularProgress}`]: {
    alignSelf: 'center',
    marginTop: theme.spacing(1)
  },

  [`& .${classesIP.Box}`]: {
    marginTop: theme.spacing(1)
  },

  [`& .${classesIP.Paper}`]: {
    padding: theme.spacing(1),
    elevation: 1
  },

  [`& .${classesIP.Stack}`]: {
    alignItems: 'center',
    justifyContent: 'space-evenly',
    flexDirection: 'row',
    flexWrap: 'wrap',
    display: 'flex'
  },
  [`& .${classesIP.SubStack}`]: {
    alignItems: 'center',
    justifyContent: 'space-evenly',
    flexWrap: 'wrap',
    display: 'flex'
  },

  [`& .${classesIP.StackChildHalf}`]: {
    marginTop: theme.spacing(1),
    flex: '1 1 45%',
    padding: theme.spacing(0.5)
  },

  [`& .${classesIP.StackChildFull}`]: {
    marginTop: theme.spacing(1),
    flex: '1 1 100%',
    width: '50%'
  },

  [`& .${classesIP.Title}`]: {
    marginTop: theme.spacing(-1)
  },
  [`& .${classesIP.overviewKeyChar1StackChild}`]: {
    alignItems: 'center',
    flexWrap: 'wrap',
    spacing: 1
  }
}))
